import styled from "styled-components";

const Ground = styled.div`
  width: 100%;
  height: 5%;
  background-color: #caa472;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: large;
  font-weight: bold;
`;

export default Ground;
